import React from 'react';

/**
 * FedEx brand-compliance disclaimer. The wording is mandated verbatim by the
 * FedEx Integrator program (validation feedback 2026-09: no leading "The") and must appear (>= 8 pt) on every screen showing
 * FedEx marks or service names. English only - never localize.
 */
const FedexDisclaimer: React.FC = () => (
  // Legal feedback 2026-09-29: tertiary (#b2b2b2) was too light - use the label color (#343333).
  <div className="text-xs text-content-primary mt-2">
    FedEx service marks are owned by Federal Express Corporation and are used by permission.
  </div>
);

export default FedexDisclaimer;
